import React from 'react';
import './AdminBleedArea.css';

/**
 * @param {{
 *   children?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminBleedArea({ children, className = '' }) {
  return <div className={`au-bleed-area au-scope${className ? ` ${className}` : ''}`}>{children}</div>;
}

export default AdminBleedArea;
